export type DocumentsMX = Record<string, string[]>;

export const mapDocumentsMX = (data: DocumentsMX) => {
  const mappings: Record<string, string> = {
    architectural_plans_client: 'Planos Arquitectónicos',
    certificate_of_no_liens: 'Certificado de Tradición',
    real_folio: 'Folio Real',
    public_property_registry: 'Registro público propiedad',
    appraisal_with_notary_stamp_or_shf_infonavit_folio: 'Avalúo sello notarial',
    construction_license: 'Licencia de construcción',
    condominium_regime: 'Régimen de condominio',
    descriptive_report: 'Informe descriptivo',
    report_and_remo_measurement: 'Informe y medición REMO',
    property_tax_receipt: 'Impuesto predial',
    ownership_transfer: 'Transferencia de propiedad',
    alignment_and_official_number: 'Alineamiento y número oficial',
    deed: 'Escritura',
    additional_documents: 'Docs adicionales',
  };

  return Object.entries(mappings).flatMap(([key, title]) => {
    const fileUrls = data[key];
    if (!fileUrls || fileUrls.length === 0) return [];

    return fileUrls.map((url, index) => ({
      id: `${key}_${index}`,
      title: fileUrls.length > 1 ? `${title} (${index + 1})` : title,
      fileUrl: url,
    }));
  });
};
